module.exports = function() {
  return new Worker("/" + "typescript-transpiler.1585b49f.worker.js");
};